import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { MapIcon } from '../../../../components/Maps/components/MapIcon';
import { PRIVATE_WATER_DESCRIPTION, PRIVATE_WATER_TITLE } from './constants/constants';

export const PrivateWaterSection = () => {
  return (
    <div className="bg-pinktail-tint mx-6 mb-6 flex flex-col items-center justify-center gap-3 overflow-hidden rounded-xl p-6 sm:mx-16 sm:mb-10 md:mx-auto md:max-w-[650px]">
      <MapIcon name={'forbidden_fishing_water'} alt="forbidden fishing water icon" />
      <span className="flex flex-col gap-1">
        <Heading as="span" variant="xs" className="text-center">
          {PRIVATE_WATER_TITLE}
        </Heading>
        <Text variant="sm" className="m-0 text-center">
          {PRIVATE_WATER_DESCRIPTION}
        </Text>
      </span>
    </div>
  );
};
